import React from "react";
import { Link } from "react-router-dom";
import { Bird, ArrowLeft, Home } from "lucide-react";

// Public landing for /community when there is no active session.
// We deliberately do NOT show an email field here — members sign in
// automatically right after they sign up on the home page, and that's the
// canonical way in. This keeps the surface area small and avoids prompting
// people for their email twice.
const CommunityLogin = () => {
  return (
    <div
      className="min-h-screen flex items-center justify-center px-6 py-16"
      style={{
        background:
          "radial-gradient(1200px 600px at 50% -10%, #4a6276 0%, #354556 45%, #2b3a49 100%)",
      }}
    >
      <div className="w-full max-w-md">
        <div className="flex items-center justify-center mb-6">
          <span className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-white/10 border border-white/15 text-[#cfe7f8]">
            <Bird className="h-6 w-6" />
          </span>
        </div>
        <div className="bg-white rounded-2xl shadow-2xl p-8 text-center">
          <h1 className="ht-display text-2xl text-[#2c3e50]">
            Come into the community
          </h1>
          <p className="mt-3 ht-body text-[#5a6b7d] leading-relaxed">
            We sign you in automatically when you join from the home page.
            Please head there first &mdash; it only takes a moment.
          </p>
          <Link
            to="/#join"
            className="ht-btn mt-6 w-full inline-flex items-center justify-center gap-2 rounded-md bg-[#b6dcf3] hover:bg-[#a4d1ee] text-[#2c3e50] font-semibold py-3 text-[15px]"
          >
            <Home className="h-4 w-4" />
            Join from the home page
          </Link>
          <p className="mt-4 text-xs text-[#7e8a96]">
            Already joined on this device? Try refreshing this page. If you
            recently closed your browser tab, please join again from the home
            page &mdash; it&apos;s free and takes a few seconds.
          </p>
          <Link
            to="/"
            className="mt-5 flex items-center justify-center gap-2 text-sm text-[#3d6486] hover:text-[#2c3e50] transition-colors"
          >
            <ArrowLeft className="h-4 w-4" /> Back to site
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CommunityLogin;
